<table class="ir-plugin-table">
  <tr *ngIf="duration?.Label">
    <td class="plugin-table-cell">
      <p>
        <span style="margin-left: 10px">
          <strong>{{ duration.Label }}</strong>
        </span>
      </p>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="duration?.DurationValue">
    <td class="plugin-table-cell">
      <p>
        <span style="margin-left: 10px">
          <strong>{{ 'plugins.installationduration.duration' | translate }}</strong>
        </span>
      </p>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ duration.DurationValue }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="duration?.Units && duration?.Units >= 0">
    <td class="plugin-table-cell">
      <span style="margin-left: 10px">
        <strong>{{ 'plugins.installationduration.time-units' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ duration.Units | timeunits }}</span>
      </p>
    </td>
  </tr>
</table>
